import { Controller } from "@hotwired/stimulus";

// SAL-051: the Lineage edges as the prototype draws them: a curve from each
// node to the next column, faint at rest, strong on the lit path, nearly gone
// for the rest while something is selected. The pairs come from the server
// (Sales::LineageGraph#edges); positions are measured here and redrawn when
// the sheet changes size or the fonts arrive.
const SVG = "http://www.w3.org/2000/svg";

export default class extends Controller {
  static values = { edges: Array };

  connect() {
    this.svg = document.createElementNS(SVG, "svg");
    this.svg.setAttribute("class", "sales-lin-edges");
    this.svg.setAttribute("aria-hidden", "true");
    this.element.prepend(this.svg);
    this.observer = new ResizeObserver(() => this.schedule());
    this.observer.observe(this.element);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.schedule());
    this.draw();
  }

  disconnect() {
    this.observer.disconnect();
    this.svg.remove();
  }

  schedule() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.draw();
    });
  }

  draw() {
    const box = this.element.getBoundingClientRect();
    this.svg.setAttribute("width", box.width);
    this.svg.setAttribute("height", box.height);
    this.svg.replaceChildren();
    this.edgesValue.forEach(([fromId, toId]) => {
      const from = document.getElementById(fromId);
      const to = document.getElementById(toId);
      if (!from || !to) return;
      const a = from.getBoundingClientRect();
      const b = to.getBoundingClientRect();
      const x1 = a.right - box.left;
      const y1 = a.top + a.height / 2 - box.top;
      const x2 = b.left - box.left;
      const y2 = b.top + b.height / 2 - box.top;
      const dx = Math.max(24, (x2 - x1) / 2);
      const path = document.createElementNS(SVG, "path");
      path.setAttribute("d", `M ${x1} ${y1} C ${x1 + dx} ${y1}, ${x2 - dx} ${y2}, ${x2} ${y2}`);
      const on = from.classList.contains("is-lit") && to.classList.contains("is-lit");
      path.setAttribute("class", on ? "sales-lin-edge is-on" : "sales-lin-edge");
      path.style.setProperty("--c", getComputedStyle(to).getPropertyValue("--c"));
      this.svg.appendChild(path);
    });
  }
}
